// 순수 함수: data 객체를 받아 2페이지 분량의 HTML 문자열 배열 반환
// UsersBox.jsx, ReportsBox.jsx 양쪽에서 공유

export const MON_SHORT = ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

export const buildMonthlyReportPages = (data) => {
  const { student, issueDate, reportPeriod, levelDetail, kpi, stageResults,
          peers, monthly, prev, trend, levelTrend, aiSummary, aiGoals, nextLesson } = data
  const name      = student?.NAME || 'Student'
  const firstName = name.split(' ')[0]
  const fmtN = (v, dec = 1) => Number(v || 0).toFixed(dec)
  const stripNum = (s) => (s || '').replace(/\s*\(\d+\)\s*$/, '')
  const pTopPct = peers.paceTopPct || 100
  const pRank   = peers.paceRank   || 1

  const achieveBadgeLabel = kpi.masteryAccuracy >= 95 ? 'OUTSTANDING'
    : kpi.masteryAccuracy >= 85 ? 'EXCELLENT'
    : kpi.masteryAccuracy >= 75 ? 'STRONG'
    : kpi.masteryAccuracy >= 65 ? 'PROGRESSING'
    : 'DEVELOPING'
  const achieveBadgeBg    = kpi.masteryAccuracy >= 85 ? '#FEF3C7'
    : kpi.masteryAccuracy >= 75 ? '#DCFCE7' : '#F3F4F6'
  const achieveBadgeColor = kpi.masteryAccuracy >= 85 ? '#78350F'
    : kpi.masteryAccuracy >= 75 ? '#166534' : '#6B7280'

  const achievementText = pTopPct <= 10
    ? `Top ${pTopPct}% in Learning Pace Among Level ${student.level_num} Students`
    : kpi.masteryAccuracy >= 90
    ? `${fmtN(kpi.masteryAccuracy)}% Mastery Accuracy — Exceptional Performance`
    : kpi.masteryAccuracy >= 80
    ? `${fmtN(kpi.masteryAccuracy)}% Mastery Accuracy — Strong Performance`
    : `Consistent Growth Through Focused Review Practice`

  const prevTrend = (trend || []).filter(t => !(t.yr === reportPeriod.year && t.mo === reportPeriod.month))
  const avgTrend  = prevTrend.length > 0
    ? Number((prevTrend.reduce((s, t) => s + t.accuracy, 0) / prevTrend.length).toFixed(1))
    : null
  const trendDiffAbs = avgTrend !== null ? Math.abs(Number((monthly.accuracy - avgTrend).toFixed(1))) : null
  const trendDir     = avgTrend !== null && monthly.accuracy >= avgTrend ? 'above' : 'below'
  const insightLine  = avgTrend !== null && prevTrend.length > 0
    ? `This month's accuracy is ${trendDiffAbs}% ${trendDir} the ${prevTrend.length}-month historical average (${avgTrend}%).`
    : ''

  const cleanN = s => (s || '').replace(/\s*\(\d+\)\s*$/, '').trim()

  const header = `<div style="background:#1a2f4c;padding:15px 44px 0 44px;">
    <div style="display:flex;justify-content:space-between;align-items:center;padding-bottom:14px;border-bottom:2px solid #c9a227;">
      <div style="display:flex;align-items:center;gap:10px;">
        <div style="width:30px;height:30px;border-radius:7px;background:#c9a227;display:flex;align-items:center;justify-content:center;font-size:15px;font-weight:900;color:#1a2f4c;">M</div>
        <div>
          <div style="color:#e8c84a;font-size:10px;font-weight:800;letter-spacing:0.2em;">MHEDUSOLUTION</div>
          <div style="color:rgba(255,255,255,0.4);font-size:9px;letter-spacing:0.07em;">ENGLISH MATH FOR EARLY LEARNERS</div>
        </div>
      </div>
      <div style="text-align:right;">
        <div style="color:#fff;font-size:11px;font-weight:700;letter-spacing:0.12em;">MONTHLY PROGRESS REPORT</div>
        <div style="color:rgba(255,255,255,0.38);font-size:9px;margin-top:2px;">${MON_SHORT[reportPeriod.month]} ${reportPeriod.year} &nbsp;·&nbsp; Issued ${issueDate}</div>
      </div>
    </div>
  </div>`

  const header2 = `<div style="background:#1a2f4c;padding:9px 44px;border-bottom:1px solid rgba(201,162,39,0.3);">
    <div style="display:flex;justify-content:space-between;align-items:center;">
      <div style="display:flex;align-items:center;gap:8px;">
        <div style="width:18px;height:18px;border-radius:4px;background:#c9a227;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:900;color:#1a2f4c;">M</div>
        <div style="color:#e8c84a;font-size:9px;font-weight:800;letter-spacing:0.15em;">MHEDUSOLUTION</div>
      </div>
      <div style="color:rgba(255,255,255,0.35);font-size:9px;letter-spacing:0.04em;">${name} &nbsp;·&nbsp; ${MON_SHORT[reportPeriod.month]} ${reportPeriod.year} &nbsp;·&nbsp; Page 2 of 2</div>
    </div>
  </div>`

  const trendSvg = (() => {
    if (!trend || trend.length === 0) return ''
    const W=490, H=170, pL=6, pR=6, pT=26, pB=34
    const iW=W-pL-pR, iH=H-pT-pB, n=trend.length
    const slot=iW/n, bW=Math.min(42,slot-10)
    const yf=v=>pT+iH-(v/100)*iH
    const curYr=reportPeriod.year, curMo=reportPeriod.month
    const refY = avgTrend !== null ? yf(avgTrend) : null

    const bars=trend.map((t,i)=>{
      const x=pL+slot*i+(slot-bW)/2
      const bH=Math.max(2,(t.accuracy/100)*iH)
      const y=pT+iH-bH
      const cur=t.yr===curYr&&t.mo===curMo
      const lx=pL+slot*i+slot/2
      const col=cur?'#1a2f4c':'#C7D9F0'
      const txt=cur?'#1a2f4c':'#9CA3AF'
      return `<rect x="${x}" y="${y}" width="${bW}" height="${bH}" rx="4" fill="${col}"/>
        <text x="${lx}" y="${y-5}" text-anchor="middle" font-size="${cur?'10':'9'}" font-weight="${cur?'900':'500'}" fill="${txt}">${t.accuracy}%</text>
        <text x="${lx}" y="${H-pB+14}" text-anchor="middle" font-size="9" fill="${cur?'#1a2f4c':'#9CA3AF'}" font-weight="${cur?'800':'400'}">${MON_SHORT[t.mo]}</text>`
    }).join('')

    const apts=trend.map((t,i)=>{
      const m=(levelTrend||[]).find(r=>r.yr===t.yr&&r.mo===t.mo)
      return m?`${pL+slot*i+slot/2},${yf(m.accuracy)}`:null
    }).filter(Boolean)

    const avgLine=apts.length>1
      ?`<polyline points="${apts.join(' ')}" fill="none" stroke="#c9a227" stroke-width="1.8" stroke-dasharray="5,3" opacity="0.85"/>
        ${apts.map(p=>{const[x,y]=p.split(',');return`<circle cx="${x}" cy="${y}" r="3" fill="#c9a227" opacity="0.9"/>`}).join('')}`
      :''

    const refLine = refY !== null
      ? `<line x1="${pL}" y1="${refY}" x2="${W-pR}" y2="${refY}" stroke="#E5E7EB" stroke-width="1" stroke-dasharray="3,3"/>`
      : ''

    const legY=H-3
    const legend=apts.length>1
      ?`<rect x="${pL}" y="${legY-8}" width="12" height="8" rx="2" fill="#C7D9F0"/>
        <text x="${pL+16}" y="${legY}" font-size="8.5" fill="#9CA3AF">${firstName}</text>
        <line x1="${pL+60}" y1="${legY-4}" x2="${pL+73}" y2="${legY-4}" stroke="#c9a227" stroke-width="1.8" stroke-dasharray="5,3"/>
        <circle cx="${pL+66}" cy="${legY-4}" r="2.5" fill="#c9a227"/>
        <text x="${pL+77}" y="${legY}" font-size="8.5" fill="#9CA3AF">Level ${student.level_num} Avg</text>`
      :''

    return `<svg width="${W}" height="${H}" viewBox="0 0 ${W} ${H}" xmlns="http://www.w3.org/2000/svg">
      ${refLine}
      <line x1="${pL}" y1="${pT+iH}" x2="${W-pR}" y2="${pT+iH}" stroke="#E5E7EB" stroke-width="1"/>
      ${bars}${avgLine}${legend}
    </svg>`
  })()

  const stageColors = ['#94A3B8','#3B82F6','#10B981','#16a34a']
  const stageBg     = ['#FAFAFA','#F0F4FF','#F0FFFA','#F0FDF4']

  const page1 = `<html><head><meta charset="utf-8"/></head>
<body style="font-family:Arial,Helvetica,sans-serif;background:#fff;margin:0;padding:0;width:870px;">
<div style="width:870px;background:#fff;">

  ${header}

  <div style="padding:28px 44px 26px;background:#fff;border-bottom:1px solid #F3F4F6;display:flex;justify-content:space-between;align-items:center;">
    <div>
      <div style="font-size:10px;color:#c9a227;font-weight:800;letter-spacing:0.22em;margin-bottom:12px;">MONTHLY LEARNING REPORT</div>
      <div style="font-size:42px;font-weight:900;color:#1a2f4c;letter-spacing:-0.025em;line-height:1;">${name}</div>
      <div style="font-size:12px;color:#9CA3AF;margin-top:8px;letter-spacing:0.02em;">${student.CENTER_NAME} &nbsp;·&nbsp; Level ${student.level_num} &nbsp;·&nbsp; Learning Day ${kpi.dayNumber}</div>
    </div>
    <div style="text-align:right;">
      <div style="font-size:9px;font-weight:700;color:#9CA3AF;letter-spacing:0.12em;margin-bottom:6px;">MASTERY ACCURACY</div>
      <div style="font-size:76px;font-weight:900;color:#1a2f4c;line-height:1;letter-spacing:-3px;">${fmtN(kpi.masteryAccuracy)}%</div>
      <div style="margin-top:10px;display:inline-block;background:${achieveBadgeBg};color:${achieveBadgeColor};padding:4px 14px;border-radius:20px;font-size:10px;font-weight:800;letter-spacing:0.1em;">${achieveBadgeLabel}</div>
    </div>
  </div>

  <div style="padding:16px 36px 20px;background:#F8FAFC;border-bottom:1px solid #F3F4F6;">
    <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px;">
      <div style="padding:18px 16px;text-align:center;background:#fff;border-radius:10px;box-shadow:0 2px 10px rgba(0,0,0,0.06);border:1px solid #F3F4F6;">
        <div style="font-size:10px;color:#9CA3AF;font-weight:700;letter-spacing:0.1em;margin-bottom:8px;">FIRST TRY ACCURACY</div>
        <div style="font-size:34px;font-weight:900;color:#2563eb;letter-spacing:-1px;">${fmtN(kpi.firstTryAccuracy)}%</div>
        <div style="font-size:10px;color:#D1D5DB;margin-top:5px;">initial attempt (cumulative)</div>
      </div>
      <div style="padding:18px 16px;text-align:center;background:#fff;border-radius:10px;box-shadow:0 2px 10px rgba(0,0,0,0.06);border:1px solid #F3F4F6;">
        <div style="font-size:10px;color:#9CA3AF;font-weight:700;letter-spacing:0.1em;margin-bottom:8px;">PROBLEMS SOLVED</div>
        <div style="font-size:34px;font-weight:900;color:#7c3aed;letter-spacing:-1px;">${monthly.problems}</div>
        <div style="font-size:10px;color:#D1D5DB;margin-top:5px;">${prev && prev.problems > 0 ? `${monthly.problems >= prev.problems ? '▲' : '▼'} ${Math.abs(monthly.problems - prev.problems)} vs last month` : 'this month'}</div>
      </div>
      <div style="padding:18px 16px;text-align:center;background:#fff;border-radius:10px;box-shadow:0 2px 10px rgba(0,0,0,0.06);border:1px solid #F3F4F6;">
        <div style="font-size:10px;color:#9CA3AF;font-weight:700;letter-spacing:0.1em;margin-bottom:8px;">ACTIVE DAYS</div>
        <div style="font-size:34px;font-weight:900;color:#16a34a;letter-spacing:-1px;">${monthly.activeDays}</div>
        <div style="font-size:10px;color:#D1D5DB;margin-top:5px;">${prev ? `${monthly.activeDays >= prev.activeDays ? '▲' : '▼'} ${Math.abs(monthly.activeDays - prev.activeDays)} vs last month` : 'this month'}</div>
      </div>
    </div>
  </div>

  <div style="display:grid;grid-template-columns:268px 1fr;gap:0;border-bottom:1px solid #F3F4F6;">
    <div style="padding:22px 20px 22px 44px;border-right:1px solid #F3F4F6;">
      <div style="font-size:10px;color:#c9a227;font-weight:800;letter-spacing:0.18em;margin-bottom:18px;">LEARNING JOURNEY</div>
      <div style="display:flex;gap:0;align-items:stretch;">
        <div style="display:flex;flex-direction:column;align-items:center;margin-right:16px;flex:none;padding-top:3px;">
          <div style="width:7px;height:7px;border-radius:50%;background:#D1D5DB;"></div>
          <div style="width:1px;background:#E5E7EB;flex:1;min-height:22px;margin:5px 0;"></div>
          <div style="width:7px;height:7px;border-radius:50%;background:#D1D5DB;"></div>
          <div style="width:1px;background:#E5E7EB;flex:1;min-height:22px;margin:5px 0;"></div>
          <div style="width:7px;height:7px;border-radius:50%;background:#94A3B8;"></div>
          <div style="width:1px;background:#c9a227;flex:1;min-height:18px;margin:5px 0;opacity:0.4;"></div>
          <div style="width:12px;height:12px;border-radius:50%;background:#1a2f4c;border:2.5px solid #c9a227;"></div>
        </div>
        <div style="flex:1;display:flex;flex-direction:column;justify-content:space-between;min-width:0;gap:10px;">
          <div>
            <div style="font-size:8px;font-weight:700;color:#D1D5DB;letter-spacing:0.1em;margin-bottom:1px;">LEVEL ${student.level_num}</div>
            <div style="font-size:11px;font-weight:500;color:#CBD5E1;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${cleanN(levelDetail.unit_name)}</div>
          </div>
          <div>
            <div style="font-size:8px;font-weight:700;color:#D1D5DB;letter-spacing:0.1em;margin-bottom:1px;">CHAPTER</div>
            <div style="font-size:11px;font-weight:500;color:#9CA3AF;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${cleanN(levelDetail.chapter_name)}</div>
          </div>
          <div>
            <div style="font-size:8px;font-weight:700;color:#CBD5E1;letter-spacing:0.1em;margin-bottom:1px;">LESSON</div>
            <div style="font-size:11px;font-weight:600;color:#374151;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${cleanN(levelDetail.lesson_name)}</div>
          </div>
          <div style="background:#1a2f4c;border-radius:8px;padding:9px 12px;">
            <div style="font-size:8px;font-weight:800;color:#c9a227;letter-spacing:0.12em;margin-bottom:3px;">▶ NOW STUDYING</div>
            <div style="font-size:12px;font-weight:800;color:#fff;line-height:1.3;">${cleanN(levelDetail.sub_lesson_name)}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding:22px 28px 16px 22px;">
      <div style="font-size:10px;color:#c9a227;font-weight:800;letter-spacing:0.18em;margin-bottom:10px;">MONTHLY ACCURACY TREND
        <span style="font-size:8.5px;color:#D1D5DB;font-weight:400;letter-spacing:0;margin-left:6px;">(ANSWER_HIS · all attempts)</span>
      </div>
      ${trendSvg || '<div style="color:#9CA3AF;font-size:12px;padding:20px 0;">Not enough data</div>'}
      ${insightLine ? `<div style="font-size:10px;color:#6B7280;font-style:italic;margin-top:10px;line-height:1.6;padding:8px 12px;background:#FAFAFA;border-radius:6px;border-left:3px solid #E5E7EB;">${insightLine}</div>` : ''}
    </div>
  </div>

  <div style="margin:20px 44px 18px;background:linear-gradient(135deg,#1a2f4c 0%,#243d5e 100%);border-radius:12px;padding:22px 32px;position:relative;overflow:hidden;">
    <div style="position:absolute;left:0;top:0;bottom:0;width:5px;background:#c9a227;border-radius:4px 0 0 4px;"></div>
    <div style="font-size:9px;font-weight:800;color:#c9a227;letter-spacing:0.22em;margin-bottom:8px;">★ &nbsp;ACHIEVEMENT RECOGNITION</div>
    <div style="font-size:20px;font-weight:900;color:#fff;line-height:1.25;letter-spacing:-0.01em;">${achievementText}</div>
    <div style="font-size:10px;color:rgba(255,255,255,0.38);margin-top:7px;font-style:italic;">${MON_SHORT[reportPeriod.month]} ${reportPeriod.year} Evaluation &nbsp;·&nbsp; Issued ${issueDate}</div>
  </div>

  <div style="padding:0 44px 14px;display:flex;justify-content:space-between;align-items:center;">
    <div style="font-size:9px;color:#D1D5DB;letter-spacing:0.06em;">✦ Summary and goals generated with AI assistance</div>
    <div style="font-size:9px;color:#D1D5DB;letter-spacing:0.06em;">Page 1 of 2</div>
  </div>
</div>
</body></html>`

  const summaryText = aiSummary || `${firstName} demonstrated strong commitment this month, completing ${monthly.problems} problems with ${fmtN(kpi.firstTryAccuracy)}% first-try accuracy and achieving ${fmtN(kpi.masteryAccuracy)}% mastery accuracy through the full review cycle. Ranked #${pRank} of ${peers.count} Level ${student.level_num} students in learning pace, ${firstName} is making meaningful and measurable progress.`

  const paceMax = Math.max(peers.studentPace, peers.avgPace, 0.1) * 1.3
  const sPaceW  = Math.min(100, Math.round((peers.studentPace / paceMax) * 100))
  const aPaceW  = Math.min(100, Math.round((peers.avgPace / paceMax) * 100))
  const accMax  = Math.max(peers.studentMasteryAcc, peers.avgMasteryAcc, 0.1) * 1.1
  const sAccW   = Math.min(100, Math.round((peers.studentMasteryAcc / accMax) * 100))
  const aAccW   = Math.min(100, Math.round((peers.avgMasteryAcc / accMax) * 100))

  const stageRows = stageResults.map((s, i) => {
    const barW = Math.min(100, Math.round(s.accuracy))
    return `<tr>
    <td style="padding:12px 16px;border-left:4px solid ${stageColors[i]};background:${stageBg[i]};">
      <div style="font-size:12px;font-weight:800;color:#374151;">${s.stage}</div>
      <div style="font-size:9.5px;color:#9CA3AF;margin-top:2px;">${s.desc}</div>
    </td>
    <td style="padding:12px 16px;text-align:center;font-size:12px;color:#6B7280;background:${stageBg[i]};">${s.total}</td>
    <td style="padding:12px 16px;text-align:center;font-size:12px;font-weight:700;color:#16a34a;background:${stageBg[i]};">${s.correct}</td>
    <td style="padding:12px 16px;text-align:center;font-size:12px;color:#e74c3c;background:${stageBg[i]};">${s.wrong}</td>
    <td style="padding:12px 20px 12px 12px;background:${stageBg[i]};">
      <div style="display:flex;align-items:center;gap:8px;justify-content:flex-end;">
        <div style="background:#E5E7EB;border-radius:3px;height:5px;width:60px;flex:none;">
          <div style="background:${stageColors[i]};height:5px;border-radius:3px;width:${barW}%;"></div>
        </div>
        <span style="font-size:13px;font-weight:900;color:${stageColors[i]};min-width:38px;text-align:right;">${s.accuracy}%</span>
      </div>
    </td>
  </tr>`
  }).join('')

  const hasGoals = Array.isArray(aiGoals) && aiGoals.length > 0
  const hasNext  = nextLesson && nextLesson.lesson_name
  const pctBarW  = Math.min(100, Math.max(2, 100 - pTopPct))

  const page2 = `<html><head><meta charset="utf-8"/></head>
<body style="font-family:Arial,Helvetica,sans-serif;background:#fff;margin:0;padding:0;width:870px;">
<div style="width:870px;background:#fff;">

  ${header2}

  <div style="padding:24px 44px 20px;border-bottom:1px solid #F3F4F6;">
    <div style="font-size:10px;color:#c9a227;font-weight:800;letter-spacing:0.22em;margin-bottom:14px;">TEACHER'S SUMMARY &nbsp;—&nbsp; ${MON_SHORT[reportPeriod.month]} ${reportPeriod.year}</div>
    <div style="display:flex;gap:18px;align-items:flex-start;">
      <div style="font-size:60px;color:#E5E7EB;font-weight:900;line-height:0.75;flex:none;margin-top:2px;">"</div>
      <div style="flex:1;">
        <div style="font-size:13px;color:#374151;line-height:1.9;">${summaryText}</div>
        <div style="margin-top:10px;font-size:9.5px;color:#9CA3AF;font-weight:600;letter-spacing:0.06em;">— Solution M Team &nbsp;·&nbsp; Math Education Specialist</div>
      </div>
    </div>
  </div>

  <div style="padding:18px 44px 18px;border-bottom:1px solid #F3F4F6;">
    <div style="font-size:10px;color:#c9a227;font-weight:800;letter-spacing:0.22em;margin-bottom:14px;">PEER COMPARISON &nbsp;<span style="font-size:9px;font-weight:400;color:#D1D5DB;letter-spacing:0;">Level ${student.level_num} · ${peers.count} Students</span></div>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:28px;">
      <div>
        <div style="font-size:9px;color:#9CA3AF;font-weight:700;letter-spacing:0.08em;margin-bottom:10px;">LEARNING PACE &nbsp;·&nbsp; sub-lessons / 30 days</div>
        <div style="margin-bottom:10px;">
          <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:5px;">
            <span style="font-size:11px;font-weight:700;color:#374151;">${firstName}</span>
            <span style="font-size:15px;font-weight:900;color:#7c3aed;">${peers.studentPace}</span>
          </div>
          <div style="background:#F3F4F6;border-radius:999px;height:7px;"><div style="background:#7c3aed;height:7px;border-radius:999px;width:${sPaceW}%;"></div></div>
        </div>
        <div>
          <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:5px;">
            <span style="font-size:11px;color:#CBD5E1;">Level ${student.level_num} Average</span>
            <span style="font-size:12px;color:#CBD5E1;">${peers.avgPace}</span>
          </div>
          <div style="background:#F3F4F6;border-radius:999px;height:7px;"><div style="background:#E5E7EB;height:7px;border-radius:999px;width:${aPaceW}%;"></div></div>
        </div>
      </div>
      <div>
        <div style="font-size:9px;color:#9CA3AF;font-weight:700;letter-spacing:0.08em;margin-bottom:10px;">MASTERY ACCURACY &nbsp;·&nbsp; vs peers</div>
        <div style="margin-bottom:10px;">
          <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:5px;">
            <span style="font-size:11px;font-weight:700;color:#374151;">${firstName}</span>
            <span style="font-size:15px;font-weight:900;color:#16a34a;">${fmtN(peers.studentMasteryAcc)}%</span>
          </div>
          <div style="background:#F3F4F6;border-radius:999px;height:7px;"><div style="background:#16a34a;height:7px;border-radius:999px;width:${sAccW}%;"></div></div>
        </div>
        <div>
          <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:5px;">
            <span style="font-size:11px;color:#CBD5E1;">Level ${student.level_num} Average</span>
            <span style="font-size:12px;color:#CBD5E1;">${fmtN(peers.avgMasteryAcc)}%</span>
          </div>
          <div style="background:#F3F4F6;border-radius:999px;height:7px;"><div style="background:#E5E7EB;height:7px;border-radius:999px;width:${aAccW}%;"></div></div>
        </div>
      </div>
    </div>
  </div>

  <div style="padding:16px 44px;border-bottom:1px solid #F3F4F6;">
    <div style="background:#F8FAFC;border:1px solid #E5E7EB;border-radius:12px;padding:18px 28px;display:flex;justify-content:space-between;align-items:center;box-shadow:0 1px 6px rgba(0,0,0,0.04);">
      <div>
        <div style="font-size:9px;color:#9CA3AF;font-weight:700;letter-spacing:0.14em;margin-bottom:8px;">CURRENT RANK &nbsp;·&nbsp; LEARNING PACE</div>
        <div style="display:flex;align-items:baseline;gap:8px;">
          <div style="font-size:44px;font-weight:900;color:#1a2f4c;line-height:1;letter-spacing:-2px;">#${pRank}</div>
          <div style="font-size:13px;color:#9CA3AF;">of ${peers.count} students</div>
        </div>
        <div style="margin-top:10px;width:180px;">
          <div style="background:#E5E7EB;border-radius:3px;height:4px;width:180px;">
            <div style="background:#1a2f4c;height:4px;border-radius:3px;width:${pctBarW}%;"></div>
          </div>
          <div style="font-size:8.5px;color:#D1D5DB;margin-top:4px;">Percentile position among Level ${student.level_num} peers</div>
        </div>
      </div>
      <div style="text-align:right;">
        <div style="font-size:30px;font-weight:900;color:#1a2f4c;line-height:1;letter-spacing:-1px;">TOP ${pTopPct}%</div>
        <div style="font-size:11px;color:#9CA3AF;margin-top:4px;">Among Level ${student.level_num} Students</div>
        <div style="margin-top:8px;display:inline-block;background:#EEF2FF;border:1px solid #C7D2FE;border-radius:16px;padding:4px 14px;font-size:10px;font-weight:700;color:#4338CA;letter-spacing:0.05em;">Learning Pace Ranking</div>
      </div>
    </div>
  </div>

  <div style="padding:18px 44px 16px;border-bottom:1px solid #F3F4F6;">
    <div style="font-size:10px;color:#c9a227;font-weight:800;letter-spacing:0.22em;margin-bottom:12px;">STAGE PROGRESS &nbsp;<span style="font-size:8.5px;font-weight:400;color:#D1D5DB;letter-spacing:0;">Cumulative · First Try → Mastery</span></div>
    <div style="border-radius:8px;overflow:hidden;border:1px solid #F3F4F6;">
      <table style="width:100%;border-collapse:collapse;">
        <thead><tr style="background:#FAFAFA;border-bottom:1px solid #F3F4F6;">
          <th style="padding:9px 16px;text-align:left;font-size:9px;font-weight:700;color:#D1D5DB;letter-spacing:0.08em;width:35%;">STAGE</th>
          <th style="padding:9px 16px;text-align:center;font-size:9px;font-weight:700;color:#D1D5DB;letter-spacing:0.08em;">TOTAL</th>
          <th style="padding:9px 16px;text-align:center;font-size:9px;font-weight:700;color:#D1D5DB;letter-spacing:0.08em;">CORRECT</th>
          <th style="padding:9px 16px;text-align:center;font-size:9px;font-weight:700;color:#D1D5DB;letter-spacing:0.08em;">WRONG</th>
          <th style="padding:9px 16px;text-align:right;font-size:9px;font-weight:700;color:#D1D5DB;letter-spacing:0.08em;">ACCURACY</th>
        </tr></thead>
        <tbody>${stageRows}</tbody>
      </table>
    </div>
  </div>

  <div style="padding:16px 44px 14px;">
    <div style="font-size:10px;color:#c9a227;font-weight:800;letter-spacing:0.22em;margin-bottom:14px;">NEXT LEARNING GOAL</div>
    <div style="display:grid;grid-template-columns:${hasNext && hasGoals ? '1fr 1fr' : '1fr'};gap:28px;align-items:start;">
      ${hasNext ? `<div>
        <div style="font-size:9px;color:#9CA3AF;font-weight:700;letter-spacing:0.1em;margin-bottom:10px;">UPCOMING TOPIC</div>
        <div style="display:flex;gap:14px;align-items:flex-start;">
          <div style="width:28px;height:28px;border-radius:50%;background:#1a2f4c;display:flex;align-items:center;justify-content:center;flex:none;font-size:11px;font-weight:900;color:#c9a227;">→</div>
          <div>
            <div style="font-size:14px;font-weight:800;color:#1a2f4c;line-height:1.35;">${cleanN(nextLesson.lesson_name)}</div>
            ${nextLesson.sub_lesson_name ? `<div style="font-size:11px;color:#9CA3AF;margin-top:4px;line-height:1.4;">${cleanN(nextLesson.sub_lesson_name)}</div>` : ''}
          </div>
        </div>
      </div>` : ''}
      ${hasGoals ? `<div>
        <div style="font-size:9px;color:#9CA3AF;font-weight:700;letter-spacing:0.1em;margin-bottom:10px;">FOCUS AREAS</div>
        ${aiGoals.map((g, idx) => `<div style="display:flex;gap:12px;align-items:flex-start;margin-bottom:10px;">
          <div style="width:22px;height:22px;border-radius:50%;background:#F8FAFC;border:1.5px solid #E5E7EB;display:flex;align-items:center;justify-content:center;flex:none;font-size:9px;font-weight:900;color:#9CA3AF;">${idx+1}</div>
          <span style="font-size:12px;color:#374151;line-height:1.5;padding-top:3px;">${g}</span>
        </div>`).join('')}
      </div>` : ''}
    </div>
  </div>

  <div style="padding:10px 44px 16px;border-top:1px solid #F3F4F6;display:flex;justify-content:space-between;align-items:center;">
    <div style="font-size:9px;color:#D1D5DB;font-weight:600;letter-spacing:0.1em;">MHEDUSOLUTION &nbsp;·&nbsp; CONFIDENTIAL</div>
    <div style="font-size:9px;color:#D1D5DB;letter-spacing:0.06em;">✦ AI-assisted &nbsp;·&nbsp; Page 2 of 2</div>
  </div>

</div>
</body></html>`

  return [page1, page2]
}
